import axios from "axios";
import { HEADERS} from "../../../../../API/UrlAndPaths";
import store from "../../../../../Redux/store";
import { get_general_list, get_general_single_list, get_profit_loss_list, get_trial_Balance_List,get_balance_sheet_list, get_gstr_report_list} from "./TrailBalanceSlice";

// general ledger
export const GeneralLedgerListAPI =async (body,setIsLoading)=>{
  setIsLoading!==undefined&&setIsLoading(true)
  console.log("=== Calling generalLedger API ===");
  console.log("Request Body:", JSON.stringify(body, null, 2));
await axios
.post("account/generalLedger", body, HEADERS)
.then((res) => {
  console.log("generalLedger Response Status:", res.status);
  console.log("generalLedger Response Data:", res.data);
  if (res.status === 200) {
    store.dispatch(get_general_list({trailBalanceList:res.data}))
    setIsLoading!==undefined&&setIsLoading(false)
  }
})
.catch((err) => {
    console.error("generalLedger API Error:");
    console.error("Error Response:", err.response);
    console.error("Error Data:", err.response?.data);
    console.error("Error Status:", err.response?.status);
    store.dispatch(get_general_list({trailBalanceList:undefined}))
    setIsLoading!==undefined&&setIsLoading(false)
});
};
export const TrailBalananceSingleListAPI =async (body,setIsLoading)=>{
  setIsLoading!==undefined&&setIsLoading(true)
  await axios
  .post("account/ledegerBalanceOfAc", body, HEADERS)
  .then((res) => {
    if (res.status === 200) {
      store.dispatch(get_general_single_list({trailBalanceSingleList:res.data}))
      setIsLoading!==undefined&&setIsLoading(false)
    }
  })
  .catch((err) => {
      store.dispatch(get_general_single_list({trailBalanceSingleList:undefined}))
      setIsLoading!==undefined&&setIsLoading(false)
      console.error(err.response);
  });
  };

  //Trial Balance

  export const trailBalanceListAPI =async (body,setIsLoading)=>{
    await axios
    .post("account/trailBalance", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        store.dispatch(get_trial_Balance_List({trailBalance:res.data}))
        setIsLoading!==undefined&&setIsLoading(false)
      }
    })
    .catch((err) => {
        store.dispatch(get_trial_Balance_List({trailBalance:undefined}))
        setIsLoading!==undefined&&setIsLoading(false)
        console.error(err.response);
    });
    };

    //profit and loss
    
    export const profitAndLossAPIcall =async (body,isLoading)=>{
      await axios
      .post("account/profitOrLossReport", body, HEADERS)
      .then((res) => {
        if (res.status === 200) {
          store.dispatch( get_profit_loss_list({profitAndLossList:res.data}))
          isLoading(false)
        }
      })
      .catch((err) => {
          store.dispatch(get_trial_Balance_List({profitAndLossList:undefined}))
          console.error(err.response);
          isLoading(false)
      });
      };
    export const ViewBalanceSheetAPIcall =async (body,isLoading)=>{
      await axios
      .post("account/viewBalanceSheet", body, HEADERS)
      .then((res) => {
        if (res.status === 200) {
          store.dispatch( get_balance_sheet_list({balanceSheetList:res.data}))
          isLoading(false)
        }
      })
      .catch((err) => {
          store.dispatch(get_balance_sheet_list({balanceSheetList:undefined}))
          console.error(err.response);
          isLoading(false)
      });
      };


    export const listGstrReportAPICall = async ({branchId, fromDate, endDate, page, limit}) => {
      try {
        const res = await axios.post("account/gstrReports/list", {
          branchId, 
          fromDate, 
          endDate,
          page,
          limit
        }, HEADERS);
        
        if (res.status === 200) {
          store.dispatch(get_gstr_report_list({ gstrReportList: res.data }));
          return res.data; // Return the complete response data
        }
        throw new Error('Unexpected response status');
      } catch (err) {
        console.error("API Error:", err.response || err);
        throw err; // Re-throw to let the caller handle it
      }
    };
  